<template>
    <div class="question-banks__question-banks-sidebar h-full">
        <div class="m-6 clearfix">
            <vs-button class="bg-primary-gradient w-full" icon-pack="feather" icon="icon-plus" icon-after @click="$emit('add')">بنك أسئلة</vs-button>
        </div>

        <VuePerfectScrollbar class="question-banks-filter-scroll-area" :settings="settings" :key="$vs.rtl">
            <div class="px-6 pb-2 flex flex-col">
              <h5 class="mb-8">النوع</h5>
              <vs-radio v-model="filter.type" vs-value="bank" class="mb-6">بنك اسئلة</vs-radio>
              <vs-radio v-model="filter.type" vs-value="quiz" class="mb-6">نماذج الإختبارات</vs-radio>
            </div>
            <vs-divider></vs-divider>
            <div class="question-banks__labels px-6 py-4">
                <h5 class="mb-8">الفصول الدراسية</h5>
                <vs-radio class="mb-6" v-model="filter.term" vs-value="current">الفصل الحالي</vs-radio>
                <vs-radio class="mb-6" v-model="filter.term" vs-value="other">الفصول السابقة</vs-radio>
            </div>
        </VuePerfectScrollbar>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelPropagation: true,
      },
    }
  },
  components: {
    VuePerfectScrollbar
  }
}

</script>

